import React from 'react';
import { Badge } from '../ui-kit';

const prioToStyle = {
  prio1: 'danger',
  prio2: 'warning',
  prio3: 'info',
  a1: 'danger',
  a2: 'warning',
  a3: 'info'
};

const PrioBadge = ({ prio }) => {
  if (!prio) return <span />;

  return (
    <Badge variant={prioToStyle[prio]} style={{ verticalAlign: 'top' }}>
      {prio}
    </Badge>
  );
};

export default PrioBadge;
